"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get VerifyEmailRequestSchema () {
        return VerifyEmailRequestSchema;
    },
    get VerifyEmailResponseSchema () {
        return VerifyEmailResponseSchema;
    }
});
const _zod = require("zod");
const VerifyEmailRequestSchema = _zod.z.object({
    token: _zod.z.string().min(1)
});
const VerifyEmailResponseSchema = _zod.z.object({
    userId: _zod.z.string().min(1),
    emailVerified: _zod.z.literal(true)
});
